module.exports = __webpack_public_path__ + "img/ico_popup_loaction.c750aa79.svg";